import React from 'react';
import styled from 'styled-components';
import { ESListing } from '@bb/domain/dist/types';
import { ListingLabelContext } from 'contexts';
import { Text } from '../Typography';
import theme from '../theme';

const StyledText = styled(Text)<{ $color: string; $textTransform: string }>`
  color: ${({ $color }) => $color};
  text-transform: ${({ $textTransform }) => $textTransform};
`;

export type AvailabilityProps = {
  availability?: ESListing['availability'];
  ellipsis?: boolean;
};

export const Availability: React.FC<AvailabilityProps> = ({
  availability,
  ellipsis,
}) => {
  const { getAvailability } = React.useContext(ListingLabelContext);

  const componentProps = () => {
    const success = theme.getColor('success');
    const danger = theme.getColor('danger');
    const info = theme.getColor('info');

    let $color = '';
    let $textTransform = '';

    switch (availability) {
      case 'Sold':
      case 'Leased':
        $color = success;
        $textTransform = 'uppercase';
        break;
      case 'Terminated':
      case 'Suspended':
      case 'Expired':
        $color = danger;
        $textTransform = 'uppercase';
        break;
      case 'Sold Conditionally':
      case 'Leased Conditionally':
        $color = info;
        break;
      default:
        break;
    }

    const formattedAvailability = availability
      ? getAvailability(availability, { condensed: true })
      : '';

    return {
      $color,
      $textTransform,
      children: formattedAvailability,
    };
  };

  return <StyledText {...componentProps()} ellipsis={ellipsis} />;
};

export default Availability;
